import { createFileRoute } from "@tanstack/react-router";

import { AdminAgentsScreen } from "@/features/admin/screens/AdminAgents";

export const Route = createFileRoute("/_authenticated/(admin)/admin/agents")({
  component: AdminAgentsScreen,
});
